import React from 'react';
import { Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { lightColours } from '../../../../styles/colours';
import { trackEvent } from '../../../../analytics';

const OptionsToggleButton = ({ showMoreOptions, setShowMoreOptions }) => {
  return (
    <Button
      variant="contained"
      onClick={() => {
        setShowMoreOptions((prev) => {
          const newState = !prev;
          // Track the button click with GA4
          trackEvent("Input Form", "Toggle Options", newState ? "Show More" : "Hide Options");
          return newState;
        });
      }}
      fullWidth
      sx={{
        fontSize: '1rem',
        px: 3,
        py: 1.5,
        backgroundColor: lightColours.darkBlue,
        color: 'white',
        '&:hover': {
          backgroundColor: lightColours.darkBlue,
        },
        boxShadow: 0,
        borderRadius: 0, // flush with container edges
      }}
      startIcon={
        showMoreOptions ? <ExpandLessIcon /> : <ExpandMoreIcon />
      }
    >
      {showMoreOptions ? 'Hide Additional Details' : 'Enter Additional Details'}
    </Button>
  );
};

export default OptionsToggleButton;
